import { RichText } from "@wordpress/block-editor";
import { useContext } from "@wordpress/element";
import BlockContext from "../context/blockContext";
import { __ } from "@wordpress/i18n";
const About = ({ section, index }) => {
	const {updateField, formatDate } = useContext(BlockContext);
	return (
	<div className="cv-about">
		<div className="about-content-wrap">
	
			<RichText
				className="description"
				value={section.description}
				id="contentGeResult"
				onChange={(value) => updateField(index, "description", value)}
			/>
			{section.dateOfBirth && (
				<div className="birth-date-wrap">
					<strong>{__('Date of Birth', 'cv-builder')}: </strong> {formatDate(section.dateOfBirth)}
				</div>
			)}
			{section.nationality && (
				<div className="nationality-wrap">
					<strong>{__('Nationality', 'cv-builder')}: </strong>
					<RichText
						tagName="span"
						value={section.nationality}
						onChange={(value) => updateField(index, "nationality", value)}
					/>
				</div>
			)}
		</div>
	</div>
)};

export default About;
